<template>
	<div class="go-back-container-wrapper">
		<b-container class="go-back">
			<b-nav small v-if="this.value" class="go-back-nav">
				<b-nav-item v-if="backToList == 1" ref="navLcrBackToList" :class="{'go-back-nav-item':true, 'no-border':true, 'nav-item-back-to-list-arrow':true}" :to="url"><span><b-img src="/img/nav/icon-back.svg" alt="menu" /><span v-html="label"></span></span></b-nav-item>
				<b-nav-item v-if="backToList == null"  :class="{'go-back-nav-item':true, 'no-border':true, 'nav-item-back-to-list-arrow':true}" :to="url"><span><b-img src="/img/nav/icon-back.svg" alt="menu" /><span v-html="label"></span></span></b-nav-item>
			</b-nav>
		</b-container>
	</div>
</template>
<script>
export default {
	props: ['value', 'url', 'label', 'backToList'],
};
</script>
